module.exports = __webpack_public_path__ + "static/img/s78.d0fe394b.png";